import { useEffect, useState } from 'react';
import { useWindowSize } from 'usehooks-ts';
import { type ScreenSize } from '@/types';
import { useAppSelector } from '@/redux/store';
import { ConfigSlice } from '@/redux/config';

export default function useScreenSize(): keyof ScreenSize {
  const { break1, break2, break3, break4, break5 } = useAppSelector(ConfigSlice.selectors.screenSizeBreakpoints);
  const { width } = useWindowSize({ initializeWithValue: true, debounceDelay: 300 });
  const [size, setSize] = useState<keyof ScreenSize>('xxxs');

  useEffect(() => {
    if (width <= break5) {
      setSize('xxxs');
    } else if (width > break5 && width <= break4) {
      setSize('xxs');
    } else if (width > break4 && width <= break3) {
      setSize('xs');
    } else if (width > break3 && width <= break2) {
      setSize('sm');
    } else if (width > break2 && width <= break1) {
      setSize('md');
    } else if (width > break1) {
      setSize('lg');
    }
  }, [width, break1, break2, break3, break4, break5]);

  return size;
}
